<template>
  <div>
    <b-field label-position="on-border">
      <template slot="label">
        <div class="label__row">
          <div class="label__col">
            {{ label }}
          </div>
          <div class="label__col label__append">
            <a @click.prevent="clearValues" v-if="input !== ''">
              <b-tooltip label="Очистить" position="is-top">
                <span class="icon is-small">
                  <i class="mdi mdi-close"></i>
                </span>
              </b-tooltip>
            </a>
          </div>
        </div>
      </template>
      <b-autocomplete
        placeholder="Выберите значение"
        :open-on-focus="true"
        :keep-first="true"
        :data="filteredData"
        field="name"
        v-model="input"
        @input="emitInput"
      >
        <template slot-scope="props">
          {{ props.option.name }}
          <div class="is-size-7 has-text-grey-light" v-if="props.option.internalId">
            [* {{ optionCurrentValue(props.option) }}]
          </div>
        </template>
      </b-autocomplete>
    </b-field>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    field: {
      type: String,
      required: true
    },
    level: {
      type: [String, Number]
    },
    data: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      required: false
    },
    returnType: {
      type: String,
      default: 'array'
    },
    value: {
      // TODO Явно определить типы, использовать массивы
      type: [Array, String, Number]
    }
  },
  mounted() {
    if (Array.isArray(this.value) && this.value.length > 0) {
      const selectedValue = this.data.find(value => value.name === this.value[0].name);
      this.selected = selectedValue;
      this.input = selectedValue.name;
    }
  },
  data() {
    return {
      input: '',
      selected: {}
    };
  },
  methods: {
    optionCurrentValue(option) {
      const optionValue = this.data.find(value => {
        return value.id == option.id && !value.internalId;
      });

      return optionValue.name;
    },

    clearValues() {
      this.input = '';
    },

    emitInput() {
      this.selected = this.data.find(value => value.name === this.input);

      if (Array.isArray(this.value)) {
        if (this.selected) {
          this.$emit('input', [this.selected]);
        } else {
          this.$emit('input', []);
        }
      } else {
        this.$emit('input', this.selected ? this.selected.id : '');
      }
    }
  },
  computed: {
    filteredData() {
      const filtered = this.data.filter(option => {
        if (this.level) {
          return (
            option.name
              .toString()
              .toLowerCase()
              .indexOf(this.input.toLowerCase()) >= 0 && option.level == this.level
          );
        } else {
          return (
            option.name
              .toString()
              .toLowerCase()
              .indexOf(this.input.toLowerCase()) >= 0
          );
        }
      });

      return filtered;
    }
  }
};
</script>

<style lang="scss" scoped>
.label {
  &__row {
    display: flex;
  }

  &__append {
    margin-left: auto;
  }
}

.clear {
  font-weight: normal;
  cursor: pointer;
}
</style>
